<template>
  <section id="container" class="gnb_pdt">
    <div>
      <div class="title_wrap">
        <h1>발송 수정 [{{ sendInfo.sendScnNm }}]</h1>
      </div>
    </div>

    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>기본정보</h2>
      </div>
      <div class="cmdp_photo">
        <span>
          <img
              v-show="fileSrc !== null"
              :src="fileSrc"
          >
          <img v-show="fileSrc == null" src="@/assets/img/etners-main/aiportal_img.png">
        </span>
         <div class="upload">
            <send-file-upload
                ref="fileUploadRef"
                @child="getFileData"
                v-bind:file="[]"
            >
            </send-file-upload>
          </div>
      </div>
      <ul class="filter_list user_photo_right">
        <li>
          <dd>
            <label>No.</label>
            <ul class="w75">
              <li>
                <span v-if="sendInfo.itemId !== null"> {{ sendInfo.itemId }}</span>
                <span v-else class="forg"> 등록 시 자동 생성 </span>
              </li>
            </ul>
          </dd>
          <dd>
            <label>진행 상태</label>
            <ul class="w50">
              <li class="w100">
                {{ sendInfo.statusNm }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
           <dd>
            <label>등록자</label>
            <ul class="w50">
              <li class="w100">
                {{ sendInfo.frstRgstId }} &nbsp; | &nbsp; {{ sendInfo.frstRgstDt}}
              </li>
            </ul>
          </dd>
          <dd>
            <label>용도<span class="forg">*</span></label>
            <ul class="w80">
              <li>
                <div v-for="item in ppsScnList">
                  <input
                      class="k-radio"
                      type="radio"
                      name="ppsScnDeli1"
                      :id="`${item.cdId}_ppsScn1`"
                      @change="sendInfo.ppsScn = item.cdId"
                      :value="item.cdId"
                      :checked="item.cdId === sendInfo.ppsScn">
                  <label :for="`${item.cdId}_ppsScn1`" class="k-radio-label" style="width:100px">{{ item.cdNm }}</label>
                </div>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            &nbsp;
          </dd>
          <dd>
            <label>취급 구분</label>
            <ul class="w75">
              <li> {{ sendInfo.sendScnNm }} </li>
            </ul>
          </dd>
        </li>
        <li>
           <dd>
            &nbsp;
          </dd>
          <dd>
            <label>특송사<span class="forg">*</span></label>
            <ul class="w80">
              <li>
                <div v-for="item in sendShpcScnList">
                  <input
                      class="k-radio"
                      type="radio"
                      name="sendShpcScnExpr2"
                      :id="`${item.cdId}_shpcScn2`"
                      :value="item.cdId"
                      @change="sendInfo.shpcScn = item.cdId"
                      :checked="item.cdId === sendInfo.shpcScn">
                  <label :for="`${item.cdId}_shpcScn2`" class="k-radio-label" style="width:90px">{{ item.cdNm }}</label>
                </div>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            &nbsp;
          </dd>
          <dd>
            <label>운송장 번호
              <span v-show="sendInfo.sendScn === '03'" class="forg">*</span>
            </label>
            <ul>
              <li v-show="sendInfo.sendScn === '02' && sendInfo.ilyangBlNoYn === 'Y'">{{ sendInfo.blNo }}</li>
              <li v-show="sendInfo.sendScn !== '02' || sendInfo.ilyangBlNoYn === 'N'">
                <kendo-maskedtextbox
                    class="w100"
                    :class="{'error' : errorTarget === 'blNo'}"
                    v-model.trim="sendInfo.blNo"
                    maxlength="50"
                    :placeholder="'운송장 번호를 입력하세요.'"
                >
                </kendo-maskedtextbox>
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>

    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>임직원 정보[보내는 분]</h2>
      </div>
      <ul class="filter_list">
        <li>
          <dd>
            <label>사업장/거점<span class="forg">*</span></label>
            <ul class="w50">
              <li>
                <div class="box_flex">
                <kendo-dropdownlist
                    class="w50"
                    :class="{'error' : errorTarget === 'facility'}"
                    ref="facilityRef"
                    v-model="sendInfo.facility"
                    :data-text-field="'cdNm'"
                    :data-value-field="'cdId'"
                    :data-source="zone1DepthList"
                    :option-label="'사업장을 선택해주세요.'"
                    @change="sendInfo.lockerId=null; sendInfo.area = null; onChangeFacility();"
                >
                </kendo-dropdownlist>
                 <kendo-dropdownlist
                    class="w50 mgl5"
                    :class="{'error' : errorTarget === 'area'}"
                    ref="areaRef"
                    v-model="sendInfo.area"
                    :data-source="zone2DepthList"
                    :data-text-field="'cdNm'"
                    :data-value-field="'cdId'"
                    :option-label="'사업장 선택 후 선택해주세요.'"
                    @change="sendInfo.lockerId=null; onChangeArea();"
                >
                </kendo-dropdownlist>
                </div>
              </li>
            </ul>
          </dd>
        </li>
         <li>
          <dd>
            <label>발신 부서<span class="forg">*</span></label>
            <ul class="w50">
              <li>
                <kendo-maskedtextbox
                    class="w100"
                    :class="{'error' : errorTarget === 'sendDept'}"
                    ref="sendDeptRef"
                    v-model.trim="sendInfo.sendDept"
                    maxlength="50"
                    :placeholder="'발신 부서를 입력하세요.'"
                >
                </kendo-maskedtextbox>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>발신<span class="forg">*</span></label>
            <ul class="w50">
              <li>
                <kendo-maskedtextbox
                    class="w100"
                    :class="{'error' : errorTarget === 'sendNm'}"
                    ref="sendNmRef"
                    v-model.trim="sendInfo.sendNm"
                    maxlength="20"
                    :placeholder="'발신 정보를 입력하세요.'"
                >
                </kendo-maskedtextbox>
              </li>
            </ul>
          </dd>
           <dd>
            <label>사원 번호<span class="forg">*</span></label>
            <ul class="w50">
              <li>
                <kendo-maskedtextbox
                    class="w100"
                    :class="{'error' : errorTarget === 'sendSabun'}"
                    v-model.trim="sendInfo.sendSabun"
                    maxlength="20"
                    :placeholder="'사원 번호를 입력하세요.'"
                >
                </kendo-maskedtextbox>
              </li>
            </ul>
          </dd>
        </li>
        <li>
           <dd>
            <label>전화 번호<span class="forg">*</span></label>
            <ul class="w50">
              <li>
                <kendo-maskedtextbox
                    class="w100"
                    :class="{'error' : errorTarget === 'sendTel'}"
                    v-model.trim="sendInfo.sendTel"
                    maxlength="20"
                    :placeholder="'전화번호를 입력하세요.'"
                >
                </kendo-maskedtextbox>
              </li>
            </ul>
          </dd>
          <dd>
            <label>이메일</label>
            <ul class="w50">
              <li>
                <kendo-maskedtextbox
                    class="w100"
                    :class="{'error' : errorTarget === 'sendMailAddr'}"
                    v-model.trim="sendInfo.sendMailAddr"
                    maxlength="50"
                    :placeholder="'이메일을 입력하세요.'"
                >
                </kendo-maskedtextbox>
              </li>
            </ul>
          </dd>
        </li>

      </ul>
      <ul class="filter_list">
        <li>
           <dd>
            <label>대리 발송</label>
            <ul class="w50">
              <li>
                <input
                    type="checkbox"
                    id="steadYn"
                    :checked="sendInfo.steadYn === 'Y'"
                    class="k-checkbox"
                    @click="sendInfo.steadYn = (sendInfo.steadYn === 'Y' ? 'N' : 'Y'); onChangeSteadYn(sendInfo.steadYn);"
                >
                <label for="steadYn" class="k-checkbox-label"><span class="mgl10">대리인 지정</span></label>
              </li>
            </ul>
          </dd>
        </li>
          <li>
           <dd>
            <label>대리 발송인<span v-if="sendInfo.steadYn === 'Y'" class="forg">*</span></label>
            <ul class="w50">
              <li>
                <kendo-maskedtextbox
                    class="w100"
                    :class="{'error' : errorTarget === 'steadNm'}"
                    v-model.trim="sendInfo.steadNm"
                    maxlength="20"
                    :disabled="sendInfo.steadYn === 'N'"
                    :placeholder="'대리 발송인을 입력하세요.'"
                >
                </kendo-maskedtextbox>
              </li>
            </ul>
          </dd>
          <dd>
            <label>대리 발송인 부서<span v-if="sendInfo.steadYn === 'Y'" class="forg">*</span></label>
            <ul class="w50">
              <li>
                <kendo-maskedtextbox
                    class="w100"
                    :class="{'error' : errorTarget === 'steadDept'}"
                    v-model.trim="sendInfo.steadDept"
                    maxlength="50"
                    :disabled="sendInfo.steadYn === 'N'"
                    :placeholder="'대리 발송인 부서를 입력하세요.'"
                >
                </kendo-maskedtextbox>
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>

    <!-- 상세 정보[보내시는 분] -->
    <send-upsert-regi
        ref="sendUpdateDetailRef"
        v-if="sendInfo.sendScn === '01'"
        :propsSendInfo="sendInfo"
        :lockerNmDataSource="lockerNmDataSource"
    ></send-upsert-regi>
    <send-upsert-deli
        v-if="sendInfo.sendScn === '02'"
        ref="sendUpdateDetailRef"
        :propsSendInfo="sendInfo"
        :lockerNmDataSource="lockerNmDataSource"
    ></send-upsert-deli>
    <send-upsert-expr
        v-if="sendInfo.sendScn === '03'"
        ref="sendUpdateDetailRef"
        :propsSendInfo="sendInfo"
        :lockerNmDataSource="lockerNmDataSource"
    ></send-upsert-expr>



    <div class="button_area w30">
      <ul>
        <li class="w25"><button class="large_btn" @click="redirectToList">목록</button></li>
        <li class="w25"><button class="large_btn orange" @click="sendUpdate">저장</button></li>
      </ul>
    </div>
  </section>
</template>
<script>


import SendFileUpload from "@/components/send/SendFileUpload.vue";
import SearchSendNm from "@/components/send/SearchSendNm.vue";
import DaumPostcodeWindow from "@/components/DaumPostcodeWindow.vue";

import SendUpsertRegi from "@/components/send/SendUpsertRegi";
import SendUpsertExpr from "@/components/send/SendUpsertExpr";
import SendUpsertDeli from "@/components/send/SendUpsertDeli";
import {LogisticsCodeDtlMixin, ZoneMixin} from "@/mixin/Mixin";

import EtnersCommonUtil from "@/common/etners.common.util";
import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";
import EtnersLogisticsUtil from "@/common/etners.logistics.util";

export default {
  name: "SendUpdate",
  components: {SendUpsertRegi, SendUpsertExpr, SendUpsertDeli, SendFileUpload, SearchSendNm, DaumPostcodeWindow},
  mixins: [LogisticsCodeDtlMixin, ZoneMixin],
  mounted() {
    const vm = this
    this.$nextTick(() => {
      vm.getSendDetail()
    })
  },
  methods: {
    getSendDetail () {
      const vm = this
      const param = {
        loginUserToken: vm.loginUserToken,
        sendId: vm.$route.params.sendId,
      }

      const jsonUrl = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/sendDetail.json`
      ApiUtil.post(jsonUrl, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }

        const resultData = response.data.resultData

        vm.sendInfo = resultData
        if (resultData.fileInfo !== null) {
          vm.fileSrc = `${ApiConfig.eklDomain}/files/2000/${resultData.fileInfo.fileId}/0?lutk=${vm.loginUserToken}`
        }

        // 특송사 리스트 세팅
        if (vm.sendInfo.sendScn === '01') {
          // 등기
          vm.sendShpcScnList = vm.sendShpcScnList.filter(item => {
            if (item.cdId === '05') {
              return item
            }
          })
        } else if (vm.sendInfo.sendScn === '02') {
          // 택배
          vm.sendShpcScnList = vm.sendShpcScnList.filter(item => {
            if (item.cdId === '04') {
              return item
            }
          })
        } else if (vm.sendInfo.sendScn === '03') {
          // 해외 특송
          vm.sendShpcScnList = vm.sendShpcScnList.filter(item => {
            // 04: 일양택배, 05: 우체국
            if (item.cdId !== '04' && item.cdId !== '05') {
              return item
            }
          })
        }

        // 사업장 세팅
        vm.$refs.facilityRef.kendoWidget().value(vm.sendInfo.facility)
        vm.onChangeFacility()
        vm.getLockerNmList(vm.sendInfo.area)

        // 대리발송 여부 체크
        if (vm.sendInfo.steadYn === 'N') {
          vm.sendInfo.steadNm = null
          vm.sendInfo.steadDept = null
          vm.sendInfo.steadTel = null
          vm.sendInfo.steadMailAddr = null
        }
      })
    },
    getLockerNmList (area) {
      const vm = this
      if(!!!area) {
        vm.lockerNmDataSource = []
        return
      }
      const param = {
        loginUserToken: vm.loginUserToken,
        area: area
      }

      const jsonUrl = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/kiosk/locker/lockerNmList.json`
      ApiUtil.post(jsonUrl, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus

        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }

        const resultData = response.data.resultData

        // 보관 위치 디폴트 세팅
        vm.lockerNmDataSource = resultData
        if (!!!vm.sendInfo.lockerId && resultData.length > 0) {
          vm.sendInfo.lockerId = resultData[0].lockerId
        }
      })
    },
    onChangeFacility () {
      const vm = this
      vm.onChange1Depth('facilityRef')
      vm.$refs.areaRef.kendoWidget().setDataSource(vm.zone2DepthList)
      vm.$refs.areaRef.kendoWidget().value(vm.sendInfo.area)
    },
    onChangeArea () {
      const vm = this
      vm.sendInfo.area = vm.$refs.areaRef.kendoWidget().value()
      vm.getLockerNmList(vm.sendInfo.area)
    },
    onChangeSteadYn (steadYn) {
      const vm = this
      if (steadYn === 'Y') {
        // 발송인 정보 초기화
        vm.sendInfo.steadNm = null
        vm.sendInfo.steadDept = null
      } else {
        vm.sendInfo.steadNm = vm.sendInfo.sendNm
        vm.sendInfo.steadDept = vm.sendInfo.sendDept
      }
    },
    getSendInfo () {
      const vm = this
      let refs = vm.$refs.sendUpdateDetailRef.$refs

      let sendInfo = vm.sendInfo

      // 사업장
      if(!!refs.facilityRef) {
        sendInfo.facility = refs.facilityRef.kendoWidget().value()
      }
      // 거점
      if(!!refs.areaRef) {
        sendInfo.area = refs.areaRef.kendoWidget().value()
      }

      return sendInfo
    },
    sendUpdate () {
      const vm = this
      const sendScn = vm.sendInfo.sendScn
      let sendInfo = vm.sendInfo

      // 유효성 체크
      if(EtnersCommonUtil.isEmpty(sendInfo.ppsScn)) {
        kendo.alert('용도를 선택해 주세요.')
        vm.errorTarget = null
        return
      }
      if(sendScn === '03' && EtnersCommonUtil.isEmpty(sendInfo.blNo)) {
        kendo.alert('운송장 번호를 입력해 주세요.')
        vm.errorTarget = 'blNo'
        return
      }
      else if (EtnersCommonUtil.isNotEmpty(sendInfo.blNo) && !EtnersCommonUtil.isBlNo(sendInfo.blNo)){
        kendo.alert('운송장 번호는 영어와 숫자만 입력해주세요.')
        vm.errorTarget = 'blNo'
        return
      }
      if(EtnersCommonUtil.isEmpty(sendInfo.facility)) {
        kendo.alert('사업장을 선택해 주세요.')
        vm.errorTarget = 'facility'
        return
      }
      if(EtnersCommonUtil.isEmpty(sendInfo.area)) {
        kendo.alert('거점을 선택해 주세요.')
        vm.errorTarget = 'area'
        return
      }
      if(EtnersCommonUtil.isEmpty(sendInfo.sendDept)) {
        kendo.alert('발신 부서를 입력해 주세요.')
        vm.errorTarget = 'sendDept'
        return
      }
      if(EtnersCommonUtil.isEmpty(sendInfo.sendNm)) {
        kendo.alert('발신을 입력해 주세요.')
        vm.errorTarget = 'sendNm'
        return
      }
      if(EtnersCommonUtil.isEmpty(sendInfo.sendSabun)) {
        kendo.alert('사원 번호를 입력해 주세요.')
        vm.errorTarget = 'sendSabun'
        return
      } else if (!EtnersLogisticsUtil.isValidSabun(sendInfo.sendSabun)){
        kendo.alert('사원 번호를 형식에 맞게 입력해 주세요')
        vm.errorTarget = 'sendSabun'
        return
      }
      if (EtnersCommonUtil.isEmpty(sendInfo.sendTel)) {
        kendo.alert('전화 번호를 입력해 주세요')
        vm.errorTarget = 'sendTel'
        return
      } else if (!EtnersLogisticsUtil.isTelNum(sendInfo.sendTel)) {
        kendo.alert('전화 번호를 형식에 맞게 입력해 주세요.')
        vm.errorTarget = 'sendTel'
        return
      }
      if (EtnersCommonUtil.isNotEmpty(sendInfo.sendMailAddr) && !EtnersLogisticsUtil.isEmailDomainAllowed(sendInfo.sendMailAddr)) {
        kendo.alert(EtnersLogisticsUtil.getEmailDomainAllowedMsg(""))
        vm.errorTarget = 'sendMailAddr'
        return
      }
      if (sendInfo.steadYn === 'Y') {
        if(EtnersCommonUtil.isEmpty(sendInfo.steadNm)) {
          kendo.alert('발송인을 입력해 주세요.')
          vm.errorTarget = 'steadNm'
          return
        }
        if(EtnersCommonUtil.isEmpty(sendInfo.steadDept)) {
          kendo.alert('발송인 부서를 입력해 주세요.')
          vm.errorTarget = 'steadDept'
          return
        }
      }
      vm.errorTarget = null

      let newSendInfo = false
      newSendInfo = vm.$refs.sendUpdateDetailRef.getPropsSendInfo()
      if(!newSendInfo) {
        return
      } else {
        sendInfo = {
          ...newSendInfo,
          imgFile: sendInfo.imgFile,
          sendTel: sendInfo.sendTel.replaceAll('-', ''),
        }
      }

      vm.sendInfo = sendInfo
      // API 호출
      vm.callUpdateApi()
    },
    getSteadInfo () {
      const vm = this
      const steadYn = vm.sendInfo.steadYn
      let steadInfo = {}

      if (steadYn === 'N') {
        steadInfo.steadNm = vm.sendInfo.sendNm
        steadInfo.steadDept = vm.sendInfo.sendDept
        steadInfo.steadTel = vm.sendInfo.sendTel
        steadInfo.steadMailAddr = vm.sendInfo.sendMailAddr
      }
      return steadInfo
    },
    callUpdateApi () {
      const vm = this

      kendo.confirm("해당 건을 수정하시겠습니까?").done(() => {
        const saveUrl = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/sendManage/sendUpdate.json`
        const formData = new FormData()
        const params = {
          loginUserToken: vm.loginUserToken,
          sendInfo: {
            ...vm.getSendInfo(),
            ...vm.getSteadInfo(),
          }
        }

        if(vm.sendInfo.imgFile){
          vm.sendInfo.imgFile.forEach(function (v) {
            formData.append('file', v.rawFile)
          })
        }

        formData.append('sendUpdateRequestParam', new Blob([JSON.stringify(params)],{
          type: 'application/json',
        }))

        // API 호출
        ApiUtil.postIncludeUploadFile(saveUrl, formData).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false
          }
          kendo.alert('수정되었습니다.')

          vm.redirectToDetail()
        })
      })
    },
    redirectToDetail () {
      this.$router.push({
        name: "SendDetail",
        params: {
          sendId: this.sendInfo.sendId
        }
      })
    },
    redirectToList () {
      this.$router.push({
        name: "ManageSendList",
      })
    },
    getFileData (fileInfo) {
      const vm = this
      vm.sendInfo.imgFile = fileInfo

      // 미리보기 세팅
      setTimeout(() => {
        const raw = fileInfo[0].rawFile
        const reader = new FileReader()
        const name = fileInfo[0].name
        if (raw) {
          reader.onloadend = function () {
            vm.fileSrc = this.result
          }

          reader.readAsDataURL(raw)
        }
      })
    }
  },
  data () {
    const loginUserData = JSON.parse(sessionStorage.getItem("loginUserData"))

    return {
      loginUserToken : sessionStorage.getItem('loginUserToken'),

      // 임직원 검색 컴포넌트 용 flag 값
      isEtnersOnly: false,
      isStead: false,

      fileSrc: null,
      sendInfo: {
        // 기본 정보
        sendScnNm: null,
        sendScn: null,
        shpcScnNm: null,
        shpcScn: null,

        ppsScn: null, // 용도
        blNo: null,
        imgFile: null,
        sendId: null,
        sendSn: null, // No.
        itemId: null, // 물품 코드
        statusNm: null,
        status: null,

        facility: loginUserData.facility,
        area: loginUserData.area,

        sendNm: null, // 발신
        sendDept: null,
        sendSabun: null,
        sendTel: null,
        sendMailAddr: null,

        receiveNm: null,
        receiveTel: null,
        receiveAddr: null,
        receiveAddrDtl: null,
        receivePost: null,
        contents: null, //비고
        deliveryScn: null,
        contentsScn: null,
        cost: null,
        lockerId: null,
        lockerCellId: null,

        steadYn: "N",
        steadNm: null,
        steadDept: null,
        steadSabun: null,
        steadTel: null,
      },

      lockerNmDataSource: [],
      addrData : {}, // 주소 검색 컴포넌트 용
      errorTarget: null, // 유효성 체크 error 클래스 활용
    }
  }

}
</script>

<style scoped>

</style>
